import styled from "styled-components";
import { Pagination } from "../../pagination";
import { useEffect, useRef } from "react";

//STYLES
const Tbody = styled.div`
    width: 100%;
    min-height: 40px;
    border-left: thin solid rgba(0,0,0,0.06);
    border-right: thin solid rgba(0,0,0,0.06);
    overflow-y: auto;
`;

//PROPS
interface Props {
    children: React.ReactNode;
    style?: React.CSSProperties;
    paginate?: number;
    paginateFilter?: number;
    itensPage?: number;
    onChangeItensPage?: Function;
    onChangePage?: Function;
    current_page?: number;
    setCurrent_page?: React.Dispatch<React.SetStateAction<number>>;
    totalValores?: number
}

export const BodyTable: React.FC<Props> = ({ children, style, paginate, paginateFilter, onChangeItensPage, onChangePage, current_page, setCurrent_page, totalValores }) => {

    //REF
    const refCorpo = useRef<HTMLDivElement>(null);
    /** Guarda a página já exibida para não rolar na montagem inicial. */
    const pagina_anterior = useRef<number | undefined>(current_page);

    /**
     * Ao trocar de página o conteúdo é substituído, mas a barra de rolagem
     * permaneceria onde estava — o usuário cairia no meio da nova lista.
     * Volta ao topo apenas quando a página realmente muda.
     */
    useEffect(() => {
        if (pagina_anterior.current === current_page) return;
        pagina_anterior.current = current_page;
        refCorpo.current?.scrollTo({ top: 0 });
    }, [current_page]);

    return (
        <>
            <Tbody style={style} ref={refCorpo}>
                {children}
            </Tbody>
            {!!paginate && (
                <Pagination
                    paginate={paginate}
                    paginateFilter={paginateFilter}
                    onChangeItensPage={onChangeItensPage}
                    onChangePage={onChangePage}
                    current_page={current_page}
                    setCurrent_page={setCurrent_page}
                    totalValores={totalValores}
                />
            )}
        </>
    )
}